import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {JBMTableColumnType, JBMTableFilter} from "../JBMTable.component";
import {TranslateService} from 'src/app/services/multilingual/translate.service';

@Component({
  selector: 'jbm-table-column-filter',
  templateUrl: './columnfilter.component.html',
  styleUrls: ['./columnfilter.component.scss']
})
export class ColumnFilterComponent implements OnInit {
  ColType = JBMTableColumnType;
  hasFilterValues: boolean=false;
  tooltip: string=''

  @Input() name: string='';
  @Input() IDName: string=''
  @Input() filterable: boolean=false;
  @Input() columnType: JBMTableColumnType=JBMTableColumnType.string;
  @Input() filterValues: JBMTableFilter[]=[];
  @Input() filterValue: string='';
  @Input() searchMinLength: number=1;

  @Output() filterChange = new EventEmitter();

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    this.hasFilterValues = this.filterValues!==undefined && this.filterValues.length>0;
    if(this.filterValue==undefined) this.filterValue='';
    if(this.searchMinLength==undefined) this.searchMinLength=2;
  }
  onFocus() {
    if(this.columnType===JBMTableColumnType.number)
      this.tooltip=this.translateService.GetTranslation('ui.table.number-filter-tooltip')
    if(this.columnType===JBMTableColumnType.string)
      this.tooltip=this.translateService.GetTranslation('ui.search-min-'+this.searchMinLength+'-chars')
  }
  inputChange(event: any) {
    this.tooltip='';

    let value=event.target.value;
    value=value.trimLeft(); if(value.length<this.searchMinLength) value='';
    if(isNaN(parseInt(value)))
      // Emit event
      this.filterChange.emit({ name: this.name, value: value });
  }
  inputSearch(event: any) {
    if(this.columnType!==JBMTableColumnType.stringAndID)
      return
    this.filterValue=event.target.value;
    let value=parseInt(this.filterValue);
    if(!isNaN(value))
      // Emit event
      this.filterChange.emit({ name: this.IDName, value: value });
  }
  numberChange(event: any) {
    this.tooltip='';
    if(event.target.value.trim()==='')
      // Emit event
      this.filterChange.emit({ name: this.name, value: '' });
  }
  numberSearch(event: any) {
    this.filterValue = event.target.value;
    let value=parseFloat(this.filterValue.replace(',', '.'));
    if(!isNaN(value))
      // Emit event
      this.filterChange.emit({ name: this.name, value: value });
  }
  selectChange(event: any) {
    let value=event.target.value;

    // Prevent angular's check mark rendering !
    event.target.classList.remove('ng-valid');

    if(value==='') {
      // Emit event
      this.filterChange.emit( { name: this.name, value: null } );
      return false;
    }
    switch (this.columnType) {
      case JBMTableColumnType.number: {
        value=parseFloat( value.replace(',', '.') );
        break;
      }
      case JBMTableColumnType.boolean: {
        if(value==='1') value = true;
        if(value==='0') value = false;
        break;
      }
    }

    // Emit event
    this.filterChange.emit( { name: this.name, value: value } );
  }
}
